import type { CustomCellRendererProps } from "ag-grid-react";

import type { ExperienceListDto } from "@intelligems/ig-types";

import { MoreMenuExperiment } from "../MoreMenuExperiment";
import type { ExperimentListGridContext } from "./types";

export const MoreMenuCell = (
  params: CustomCellRendererProps<ExperienceListDto>
) => {
  const { scriptStatus, organization, setCurrentExperience } =
    params.context as ExperimentListGridContext;
  return (
    <MoreMenuExperiment
      scriptStatus={scriptStatus}
      organization={organization}
      experience={params.data!}
      setCurrExperience={setCurrentExperience}
      renderLocation={"overview"}
    />
  );
};
